// Copyright (c) 2017 Deere & Company

import ActionsPopoverCallback from '../../../shared/state/actions-popover-callback';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';

const createCallBack = (label, onOptionClick, onOptionClickValues) =>
    new ActionsPopoverCallback({
        label,
        onOptionClick,
        onOptionClickValues
    });

export const getSelectedLayout = (selectedLayoutName, layouts) => layouts.find(layout => layout.name === selectedLayoutName);

export const getReportLayoutActions = (actions, numberOfHiddenFields, selectedLayout) => {

    const actionList = [];

    const selectedLayoutName = selectedLayout ? selectedLayout.name : '';

    if (selectedLayoutName) {

        actionList.push(createCallBack('UPDATE_LAYOUT', actions.openUpdateLayoutModal, {}));

    }

    actionList.push(createCallBack('SAVE_AS_NEW_LAYOUT', actions.openCreateLayoutModal, {}));

    if (numberOfHiddenFields) {

        actionList.push(createCallBack('SELECT_COLUMNS', actions.showReportColumns, {}));

    }

    return actionList;

};

export const getDefaultReportLayout = (columnState, sortModel) =>
    new ReportLayout({
        columnState,
        filterModel: {},
        isDefault: false,
        name: '',
        reportName: '',
        sortModel
    });



// WEBPACK FOOTER //
// ./src/reports/shared/services/report-variant.js